<template>
  <div v-loading="loading" class="verification">
    <div class="verification_content">
      <div class="verification_title">
        {{ pageTitle ? pageTitle : $t($route.meta.title) }}
      </div>
      <div class="verification_main">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import ServiceTypeConfigAPI from "../../api/ServiceTypeConfigAPI";
import LoginAPI from "../../api/LoginAPI";
// import { getBusiness } from "@/api/Booking/BookingApplicationAPI";
import { applicationTypeFilter, wordBreak } from "@/filters";
export default {
  data() {
    return {
      loading: false,
      pageTitle: "",
    };
  },
  computed: {
    serviceType() {
      if(this.$route.name === 'BookingVerification') {
        return "HZMB_H_BOOKING";
      }
      return this.$store.state.serviceType;
    },
    applicationType() {
      return applicationTypeFilter(this.serviceType);
    },
  },
  methods: {
    logout() {
      localStorage.removeItem("authentication");
      this.loading = true;
      LoginAPI.logout()
        .then(() => {
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
  },
  async created() {
    const { businessType } = this.$route.params;
    if (businessType === "BOOKING") {
      this.pageTitle = this.$t("message.router.verify_booking");
    }
    if (
      [
        "HZMB_H_FIRST_COMP",
        "HZMB_H_RENEW_COMP",
        "HZMB_H_CANCEL_COMP",
        "HZMB_CHANGE_COMP",
        "HZMB_GH_CHANGE_COMP",
      ].includes(this.serviceType)
    ) {
      this.pageTitle = this.$t("message.router.verify_company");
    }
    this.logout();
    // console.log(localStorage.getItem("serviceType"));
    // 根據本地緩存獲取申請類型數據
    const { params, meta } = this.$route;
    let serviceType =
      params.serviceType ||
      meta.serviceType ||
      localStorage.getItem("serviceType");
    // 貨車服務處理
    if (
      [
        "HZMB_G_FIRST",
        "HZMB_G_CANCEL",
        "HZMB_G_INSURANCE",
        "HZMB_H_FIRST_PERSON",
        "HZMB_H_FIRST_PERSON",
        "HZMB_H_FIRST_COMP",
      ].includes(serviceType)
    ) {
      localStorage.setItem("serviceType", serviceType);
    }
    // 貨車預約處理
    if(this.$route.name === 'BookingVerification') {
      serviceType = "HZMB_H_BOOKING";
      localStorage.setItem("serviceType", "HZMB_H_BOOKING")
    }

    if (this.serviceType == "TAXI_ANNUAL") {
      this.$store.commit("changeVerifyForm", { type: "taxiCertNo" });
    }

    this.$store.commit("changeServiceType", serviceType);
    if (serviceType) {
      if (
        [
          "HZMB_FIRST_PERSON",
          "HZMB_FIRST_COMPANY",
          "HZMB_RENEW_PERSON",
          "HZMB_RENEW_COMPANY",
          "HZMB_MO_RENEW_PERSON",
          "HZMB_MO_RENEW_COM",
        ].includes(serviceType)
      ) {
        this.$store.commit("changeVerifyForm", {
          type: this.applicationType === "RENEW" ? "registrationNo" : "spNo",
        });
      } else {
        this.$store.commit("changeVerifyForm", { identType: "BM" });
      }
      this.loading = true;
      try {
        let config = {};
        if (this.$route.path.indexOf("/BOOKING") != -1 || this.$route.path.indexOf("/hzmb-truck-mo-booking") != -1) {
          // config = await getBusiness(serviceType);
          config = {};
        } else {
          config = await ServiceTypeConfigAPI.getDetails(serviceType);
        }
        this.loading = await false;
        config.nameTc = wordBreak(config.nameTc);
        config.nameSc = wordBreak(config.nameSc);
        config.namePt = wordBreak(config.namePt);
        config.nameEn = wordBreak(config.nameEn);
        // console.log(res);
        this.$store.commit("changeServiceTypeConfig", config);
      } catch (error) {
        this.loading = false;
        this.$error(error);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.verification {
  max-width: 1048px;
  margin: 23px auto;
}
.verification_content {
  padding: 24px 5%;
  // background: rgba(237, 238, 246, 0.39);
  min-height: 500px;
}
.verification_title {
  font-size: 20px;
  color: #38959d;
  font-weight: 500;
  line-height: 28px;
  border-left: 4px solid #38959d;
  padding-left: 20px;
}
.verification_main {
  width: 100%;
  max-width: 600px;
  margin: 24px auto;
}
@media screen and (max-width: 767px) {
  .verification {
    margin: 0 auto;
  }
}
</style>

<style lang="scss">
.submit_btn {
  text-align: center;
  margin: 76px 0;
  .gradient_btn {
    width: 300px;
    max-width: 100%;
  }
  .gradient_btn_pt {
    width: 400px;
  }
}
</style>
